import { streemLogger } from './streem_logger';
const AWS_REGION_URL = 'https://nearest-media-region.l.chime.aws/';
const TIMEOUT_MS = 5000;
const fetchAWSRegion = () => {
    return fetch(AWS_REGION_URL, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        signal: AbortSignal.timeout(TIMEOUT_MS),
    });
};
// packages/api has its own request retry logic for calls to Streem services, but it's not exported
const retryRequest = async (maxRetries, retryFn, requestName) => {
    let retries = 0;
    while (retries < maxRetries) {
        try {
            const response = await retryFn();
            if (response.ok) {
                return response;
            }
            else {
                streemLogger.warn(`Fetch call failed for ${requestName},attempt: ${retries + 1}`, {
                    status: response.status,
                });
                retries++;
            }
        }
        catch (err) {
            let errorMessage = '';
            if (err.name === 'TimeoutError') {
                errorMessage = `Fetch call timed out for ${requestName}, attempt: ${retries + 1}`;
            }
            else if (err.name === 'AbortError') {
                errorMessage = `Fetch call aborted for ${requestName}, attempt: ${retries + 1}`;
            }
            else if (err.name === 'TypeError') {
                errorMessage = `AbortSignal.timeout() method is not supported for ${requestName}, attempt: ${retries + 1}`;
            }
            else {
                errorMessage = `Fetch call failed for ${requestName}, attempt: ${retries + 1}`;
            }
            streemLogger.warn(errorMessage, {
                errorMessage: err.message,
                errorName: err.name ?? 'undefined',
            });
            retries++;
        }
    }
    throw new Error(`Failed to fetch ${requestName} after ${maxRetries} retries`);
};
export const fetchClosestMediaRegion = async () => {
    try {
        const response = await retryRequest(2, fetchAWSRegion, 'closest AWS region');
        const body = await response.json();
        return body.region;
    }
    catch (err) {
        streemLogger.error('Failed to fetch closest region', {
            errorMessage: err.message,
            stack: err.stack,
        });
        return undefined;
    }
};
//# sourceMappingURL=fetch_closest_media_region.js.map